
// src/App.tsx

import React from "react";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
} from "@azure/msal-react";
import { useAwsSession } from "./hooks/useAwsSession";
import { useSessionExpirationWarning } from "./hooks/useSessionExpirationWarning";
import { useUiSecrets } from "./hooks/useUiSecrets";

import Header from "./components/Header";
import Routes from "./components/Routes";
import Main from "./pages/Main";
import { CookieBanner } from "components/CookieBanner";
import { isDevelopment } from "./const";
import DseChatComponent from "components/DseChatComponent";
// import ChatComponent from "./components/ChatComponent";


function App() {
  const isAuthenticated = useIsAuthenticated();
  const { status: uiSecretsStatus, retry: retryUiSecrets } = useUiSecrets();
  const uiSecretsReady = uiSecretsStatus === "ready";

  // Kick off AWS‐session initialization on login:
  useAwsSession(uiSecretsReady);

  // Monitor session expiration and warn users
  useSessionExpirationWarning();

  const authenticatedContent = uiSecretsReady ? (
    <Routes />
  ) : uiSecretsStatus === "error" ? (
    <div role="alert">
      <p>Unable to load application configuration.</p>
      <button type="button" onClick={retryUiSecrets}>Retry</button>
    </div>
  ) : (
    <div role="status">Loading application configuration...</div>
  );

  return (
    <div className="app">
      <Header />

      {!isDevelopment ? (
        <>
          <AuthenticatedTemplate>
            {authenticatedContent}
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Main />
          </UnauthenticatedTemplate>
        </>
      ) : (
        isAuthenticated ? authenticatedContent : <Main />
      )}

      <CookieBanner />
      {/* Chat widget fixed at bottom-right */}
      <div className="fixed bottom-4 right-4 z-50">
        <DseChatComponent />
      </div>
    </div>
  );
}

export default App;
